import React from 'react';
import Icon from '@/components/Icon/Icon';
import useViewport from '@/common/context/ViewPort/useViewPort';
import './PromoAppliedOverlay.scss';
import type { PromoCodeData } from '@/common/interfaces/promoCode.interface';
import Overlay from '@/components/Overlay';
import { MOBILE_PROMO_APPLIED_OVERLAY } from '@/constants/Order';

interface IPromoAppliedOverlay {
  promoCodeData: PromoCodeData | undefined;
  mobPromoAppliedOverlay: boolean;
  showConfetti: boolean;
  onClose: () => void;
}

const PromoAppliedOverlay: React.FC<IPromoAppliedOverlay> = ({
  promoCodeData,
  mobPromoAppliedOverlay,
  showConfetti,
  onClose,
}) => {
  const screen = useViewport(true);
  const styleClass = `promo-code-applied--${screen}`;

  return (
    <Overlay
      isOpen={mobPromoAppliedOverlay}
      modalStyles={MOBILE_PROMO_APPLIED_OVERLAY}
      onBackdropClick={onClose}
      onCloseClick={onClose}
    >
      <div className={`${styleClass}`}>
        <Icon
          className={`${styleClass}__icon`}
          height="26px"
          width="26px"
          source="/src/assets/svg/check-circle.svg"
        />
        <p className={`${styleClass}__applied-text`}>
          <span className={`${styleClass}__applied-text__code`}>
            &apos;{promoCodeData?.code}&apos;
          </span>{' '}
          Promo Code Applied
        </p>
        <p className={`${styleClass}__saved-text`}>You Saved ${promoCodeData?.discount}</p>
        {showConfetti && (
          <img src="/src/assets/gif/confetti.gif" alt="confetti" className="confetti-gif" />
        )}
        <button type="button" onClick={onClose} className={`${styleClass}__thanks-text`}>
          Wohoo! Thanks
        </button>
      </div>
    </Overlay>
  );
};

PromoAppliedOverlay.displayName = 'PromoAppliedOverlay';

export default PromoAppliedOverlay;
